// extracted by mini-css-extract-plugin
export default {"container":"SaveOrderVIP_container__Mt9-X","saveBtn":"SaveOrderVIP_saveBtn__Rj30q","saveBtnText":"SaveOrderVIP_saveBtnText__4dWtg"};